'use client'

import { createContext, FormEvent, ReactNode, useContext, useState } from "react"
import { AuthContext } from "./authContext"
import FloatLogin from "@/components_mobile/float/login"
import FloatSignUp from "@/components_mobile/float/signUp"
import api from "@/util/api"
import FloatMypage from "@/components_mobile/float/mypage"
import customAlert from "@/util/customAlert"
import FloatPasswordChange from "@/components_mobile/float/password_change"
import FloatProfileChange from "@/components_mobile/float/profile_change"

import FloatAddAppIOS from "@/components_mobile/float/addApp"
import FloatMyinfoChange from "@/components_mobile/float/myinfo_change"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"

export const SignContext = createContext<{
    loginShow: boolean
    SetLoginShow: (show: boolean) => void
    signUpShow: boolean
    SetSignUpShow: (show: boolean) => void
    passwordShow: boolean
    SetPasswordShow: (show: boolean) => void
    changeProfileShow: boolean
    setChangeProfileShow: Function
    handlePasswordChangeSubmit: (e: FormEvent<HTMLFormElement>, id: string, password: string, password2: string, callBack?: () => void) => void
    mypageShow: boolean
    SetMypageShow: (show: boolean) => void
    UserAuthCheck: (callback: () => void) => void
    handleLoginSubmit: (e: FormEvent<HTMLFormElement>, id: string, password: string, callBack?: () => void) => void

    IOSPopupShow: boolean
    setIOSPopupShow: (show: boolean) => void

    
    myinfoShow: boolean
    SetMyinfoShow: (show: boolean) => void


}>({
    loginShow: false,
    SetLoginShow: () => { },
    signUpShow: false,
    SetSignUpShow: () => { },
    passwordShow: false,
    SetPasswordShow: () => { },
    changeProfileShow: false,
    setChangeProfileShow: () => { },
    handlePasswordChangeSubmit: () => { },
    mypageShow: false,
    SetMypageShow: () => { },
    UserAuthCheck: () => { },
    handleLoginSubmit: () => { },
    
    IOSPopupShow: false,
    setIOSPopupShow: () => { },
    
    myinfoShow: false,
    SetMyinfoShow: () => { },
    
})

export default function SignProvider({ children }: { children: ReactNode }) {
    const { user, login, logout } = useContext(AuthContext)
    const [loginShow, setLoginShow] = useState<boolean>(false)
    const [signUpShow, setSignUpShow] = useState<boolean>(false)
    const [mypageShow, setMypageShow] = useState<boolean>(false)
    const [passwordShow, setPasswordShow] = useState<boolean>(false)
    const [myinfoShow, SetMyinfoShow] = useState<boolean>(false)
    const [changeProfileShow, setChangeProfileShow] = useState<boolean>(false)
    const [IOSPopupShow, setIOSPopupShow] = useState<boolean>(false)
    const router = useRouter()

    const a = useTranslations("Sentence")

    function SetLoginShow(show: boolean) {
        setLoginShow(show)
    }
    function SetSignUpShow(show: boolean) {
        setSignUpShow(show)
    }
    function SetMypageShow(show: boolean) {
        setMypageShow(show)
    }
    function SetPasswordShow(show: boolean) {
        setPasswordShow(show)
    }
    function UserAuthCheck(callback: () => void) {
        // callback()
        if (user.is_authenticated) {
            callback()
        } else {
            SetLoginShow(true)
        }
    }

    async function handlePasswordChangeSubmit(e: FormEvent<HTMLFormElement>, id: string, password: string, password2: string, callBack?: () => void) {
        e.preventDefault()

        if (!id) {
            customAlert(a("Invalid_Username"), 'warning');
            return false;
        }
        else if (!password) {
            customAlert(a("Invalid_Password"), 'warning');
            return false;
        }
        else if (!password2) {
            customAlert(a("Invalid_PasswordConfirm"), 'warning');
            return false;
        }
        else if (password != password2) {
            customAlert(a("PasswordMismatch"), 'warning');
            return false;
        }

        const formData = new FormData()
        formData.set('username', id)
        formData.set('password', password)
        formData.set('password2', password2)

        api('/api/user/edit/password/',
            { method: "POST", body: formData})
            .then(res => res.json())
            .then(({ message, status_code }) => {
                if (status_code == 200) {
                    customAlert(a('passwordChangedRelogin'), 'success',()=>{
                        // location.reload();
                        logout()
                    })

                    if (callBack){
                        callBack();
                    }
                }else{
                    customAlert(message, 'error')
                }
            })
            .catch(()=> {
                customAlert(a("ErrorRequest"), 'error')
            })
    }
    async function handleLoginSubmit(e: FormEvent<HTMLFormElement>, id: string, password: string, callBack?: () => void) {
        e.preventDefault()

        if (!id) {
            customAlert(a("Invalid_Username"), 'warning');
            return false;
        }
        else if (!password) {
            customAlert(a("Invalid_Password"), 'warning');
            return false;
        }

        const formData = new FormData()
        formData.set('username', id)
        formData.set('password', password)

        api('/api/user/login/',
            { method: "POST", body: formData })
            .then(res => res.json())
            .then(({ data, message, status_code }) => {
                if (status_code == 200) {
                    login(data.user)

                    if (callBack){
                        callBack();
                    }
                }else{
                    customAlert(message, 'error')
                }
            })
            .catch(()=> {
                customAlert(a('CheckYourID&Password'), 'error')
            })
    }

    const propsValue = {
        loginShow,
        SetLoginShow,
        signUpShow,
        SetSignUpShow,
        passwordShow,
        SetPasswordShow,
        changeProfileShow,
        setChangeProfileShow,
        handlePasswordChangeSubmit,
        mypageShow,
        SetMypageShow,
        UserAuthCheck,
        handleLoginSubmit,
        IOSPopupShow,
        setIOSPopupShow,
        myinfoShow,
        SetMyinfoShow,
    }

    return (
        <SignContext.Provider value={propsValue}>
            {children}
            <FloatLogin />
            <FloatSignUp />
            <FloatMypage />
            <FloatPasswordChange />
            <FloatProfileChange />
            <FloatAddAppIOS />
            <FloatMyinfoChange />
        </SignContext.Provider>
    )
}